module.exports = __webpack_public_path__ + "static/media/version-control.37017a38.png";